<template>
    <div v-if="bizAuth.viewBooking.hasRight" class="page-setting biz-booking-management-default parent-frame" :class="{'fixed': listIsFixed}" v-bind:style="{'min-height': myHeight}">
        <div class="tool-bar-mask"></div>
        <booking-filter :isOpen="filterStatus" @filterClose="closeFilterMenu"></booking-filter>
        <div class="page-header has-tab">
            <h1>{{$route.meta.title}}</h1>
            <div class="btn-group">
                <table-search @changeWord="setFilterWord" :setDefault="isDefault"></table-search>
                <div class="filter" @click="openFilter()">
                    <img src="@/assets/img/icon/filter_black.svg" alt="">
                </div>
            </div>
        </div>
        <tabs :key="componentKey">
            <tab name="待業務簽約" @click="$analyticsBiz.logEvent('預定管理_待業務簽約', { screen_name: '預定管理_待業務簽約'})" :selected="selected.beSigned">
                <booking-list v-if="selected.beSigned"></booking-list>
            </tab>
            <tab name="待租客簽約" @click="$analyticsBiz.logEvent('預定管理_待租客簽約', { screen_name: '預定管理_待租客簽約'})" :selected="selected.tenantSigned">
                <booking-tenant-list v-if="selected.tenantSigned"></booking-tenant-list>
            </tab>
            <tab name="取消預定" @click="$analyticsBiz.logEvent('預定管理_取消預定', { screen_name: '預定管理_取消預定'})" :selected="selected.finished">
                <finished-list v-if="selected.finished"></finished-list>
            </tab>
        </tabs>
    </div>
</template>
<script>
import Tabs from '@/components/widge/Tabs.vue';
import Tab from '@/components/widge/Tab.vue';
import BookingTableList from '@/components/bussiness/mgtCategory/bookingMgt/bookingmgt/BookingTableList.vue';
import BookingTenantTableList from '@/components/bussiness/mgtCategory/bookingMgt/bookingmgt/BookingTenantTableList.vue';
import BookingFinishedTableList from '@/components/bussiness/mgtCategory/bookingMgt/bookingmgt/BookingFinishedTableList.vue';
import BookingFilter from '@/components/bussiness/mgtCategory/bookingMgt/bookingmgt/BookingFilter.vue';
import TableSearch from '@/components/widge/TableSearch.vue';
import { mapGetters } from 'vuex'
export default {
    data () {
        return {
            componentKey: 0,
            listIsFixed: false,
            myHeight: (window.innerHeight - 84) + 'px',
            isDefault: false,
            filterStatus: false,
            selected: {
                beSigned: false,
                tenantSigned: false,
                finished: false,
            },
        }
    },
    created (){
        this.selectTabByHash()
    },
    mounted () {
        this.$analyticsBiz.logEvent('預定管理', { screen_name: '預定管理'})
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
    },
    watch: {
        isModalMode: function (val) {
            if(val){
                document.getElementsByClassName('parent-frame')[0].style.zIndex = '9'
            }else{
                document.getElementsByClassName('parent-frame')[0].style.zIndex = '8'
            }
            
        },
        $route:{
            handler: function (val) {
                this.selectTabByHash()
            },
            // immediate: true,
            deep: true
        },
        'bizAuth.viewBooking.hasRight': function (val) {
            if(!val){
                this.$store.dispatch('setModalStatus', {state: true, type: 'bizNoRight'})
            }
        }
    },
    methods: {
        setFilterWord: function (value) {
            // this.isDefault = false
            // this.filterWord = value
            this.$store.dispatch('setBizBookingMgtFilterWord', value)
        },
        openFilter: function () {
            this.$store.commit('modalStatus/set_filter_mode', true)
            document.getElementsByClassName('parent-frame')[0].style.zIndex = '8'
            this.filterStatus = true
        },
        closeFilterMenu: function (value) {
            this.$store.commit('modalStatus/set_filter_mode', false)
            this.filterStatus = false
        },
        selectTabByHash: function () {
            let hashTag = decodeURIComponent(this.$route.hash)

            if( hashTag == '#待業務簽約' ){
                this.selected.beSigned = true
            }else if( hashTag == '#待租客簽約' ){
                this.selected.tenantSigned = true
            }else if( hashTag == '#取消預定' ){
                this.selected.finished = true
            }else{
                this.selected.beSigned = true
            }
        },
        setSelectTabAllFalse: function () {
            this.selected.beSigned = false
            this.selected.tenantSigned = false
            this.selected.finished = false
            
        },
        forceUpdate: function () {
            this.setSelectTabAllFalse()
            this.selectTabByHash()
            this.componentKey += 1; 
        },
        handleScroll: function () {
            if(!this.isModalMode){
                let scrollTop = event.target.documentElement.scrollTop
                if( scrollTop >= 50){
                    document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'none'
                    document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                }else{
                    document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
                    document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                    this.listIsFixed = false
                }

                if( scrollTop >= 115){
                    this.listIsFixed = true
                }
            }
        },
    },
    computed: {
        ...mapGetters({
            isModalMode: 'GET_MODAL_MODE',
            bizAuth: 'GET_BIZ_AUTH',
        })
    },
    components: {
        'booking-list': BookingTableList,
        'booking-tenant-list': BookingTenantTableList,
        'finished-list': BookingFinishedTableList,
        Tabs,
        Tab,
        TableSearch,
        BookingFilter
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/mgtCategory/bookingMgt/BookingMgtDefault.vue